import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { EmptyList } from "security-app/components/common";
import { GLCheckbox, RowTitleButton } from "common/components";
function ListRows({ ownerOptions, filters, ownerId, setOwnerId }) {
  const { t } = useTranslation("enterprise_security_events");
  const selectOwner = useCallback(
    (newOwner) => () => {
      const newOwnerId = newOwner.id;
      if (newOwnerId !== ownerId) {
        setOwnerId(newOwner.id);
      } else {
        setOwnerId(void 0);
      }
    },
    [ownerId, setOwnerId]
  );
  const strFilters = Object.fromEntries(Object.entries(filters).map(([key, values]) => [key, values.join(",")]));
  return ownerOptions.length < 1 ? /* @__PURE__ */ React.createElement(
    EmptyList,
    {
      filters: strFilters,
      noSearchResultText: t("users_modal.no_search_result"),
      noEntitiesExist: t("users_modal.no_entities"),
      colSpan: 3
    }
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, ownerOptions.map((owner) => /* @__PURE__ */ React.createElement("tr", { key: owner.id }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(GLCheckbox, { checked: owner.id === ownerId, onChange: selectOwner(owner) })), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: selectOwner(owner) }, owner.name)), /* @__PURE__ */ React.createElement("td", null, t(`owner_types.${String(owner.type).toLowerCase()}`, { defaultValue: owner.type })))));
}
export default ListRows;
